import React, { useEffect } from 'react'
import Link from 'next/link'
import { connect } from 'react-redux'
import Router, { useRouter } from 'next/router'
import { BurgerMenu } from 'SRC/modules/layout/Header/components/BurgerMenu'
import { setShowFilterModal, setShowNavigation } from 'SRC/modules/vehicleParts/list/actions'
import ReactSVG from 'react-svg'

const BottomNavigation = ({ filtersCount = 0, setShowFilterModal, setShowNavigation }) => {
	const router = useRouter()

	const getActiveItem = () => {
		console.log('router', router)
		if (router?.pathname === '/') return 'all_ads'
		if (router?.pathname === '/category' || router?.pathname === '/search') return 'search'

		return ''
	}

	const activeItem = getActiveItem()

	return (
		<div className='vehicle-parts-bottom-navigation'>
			<div className={`vehicle-parts-bottom-navigation_item`}>
				<Link href='/' as='/'>
					<a>
						<ReactSVG src='/icons/home.svg' beforeInjection={svg => {
							svg.setAttribute('width', '30px')
							svg.setAttribute('height', '30px')
						}} />

						<p>Svi oglasi</p>
					</a>
				</Link>

				<div className={`${activeItem === 'all_ads' ? 'active' : ''}`} />
			</div>


			<div className={`vehicle-parts-bottom-navigation_item`}>
				<a href='javascript:void(0)' onClick={() => setShowFilterModal(true)} style={{ position: 'relative' }}>
					<ReactSVG src='/icons/search.svg' beforeInjection={svg => {
						svg.setAttribute('width', '30px')
						svg.setAttribute('height', '30px')
					}} />

					<p>Pretraga</p>

					{filtersCount > 0 && (
						<div className='vehicle-parts-bottom-navigation_item-count'>
							<span>{filtersCount}</span>
						</div>
					)}
				</a>

				<div className={`${activeItem === 'search' ? 'active' : ''}`} />
			</div>

			<div className='vehicle-parts-bottom-navigation_item vehicle-parts-bottom-navigation_item--add'>
				<a href="tel:+38267733555">
					<ReactSVG src='/icons/telefon.svg' wrapper='span' className='vehicle-parts-bottom-navigation_item--add-icon' beforeInjection={svg => {
						svg.setAttribute('width', '23px')
						svg.setAttribute('height', '23px')
					}} />

					<p>Pozovi</p>
				</a>
			</div>

			<div className='vehicle-parts-bottom-navigation_item'>
				<a href='https://docs.google.com/forms/d/e/1FAIpQLSeIwWlj-5jL9xNF_RSpfpAr0OY_JtWcNaUpM14yuK3JQLxBmA/viewform?usp=dialog'>
					<ReactSVG src='/icons/b2b.svg' beforeInjection={svg => {
						svg.setAttribute('width', '30px')
						svg.setAttribute('height', '30px')
					}} />

					<p>B2B</p>
				</a>
			</div>

			<div className='vehicle-parts-bottom-navigation_item'>
				<a
					href='javascript:void(0)'
					onClick={() => setShowNavigation(true)}
				>
					<ReactSVG src='/icons/navigation.svg' beforeInjection={svg => {
						svg.setAttribute('width', '30px')
						svg.setAttribute('height', '30px')
						svg.querySelectorAll('path').forEach(path => {
							path.setAttribute('fill', '#0377cd')
						})
					}} />

					<p>Navigacija</p>
				</a>
			</div>
		</div>
	)
}

export default connect(null, { setShowFilterModal, setShowNavigation })(BottomNavigation)